<style lang="scss">

</style>

<template>
  <div class="modal fade" role="dialog" id="modalReasignaciones" aria-labelledby="modalReasignaciones">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close"
                  data-dismiss="modal" aria-label="Cerrar"><span
            aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title uppercase">
            Historial de reasignaciones / Ticket #SCM-{{ solicitudId }}
          </h4>
        </div>
        <div class="modal-body">
          <div class="table-scrollable" v-show="reasignaciones.length > 0">
            <table class="table table-bordered table-condensed table-striped vmiddle">
              <thead>
              <tr>
                <th>Vendedor</th>
                <th>Distribuidor</th>
                <th>Fecha</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(reasignacion, index) in reasignaciones" v-bind:key="index">
                <td class="form-group">
                  {{ reasignacion.vendedor }}
                </td>

                <td class="form-group">
                  {{ reasignacion.distribuidor }}
                </td>

                <td class="form-group">
                  {{ reasignacion.fecha }}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},

  data() {
    return {
      solicitudId: null,
      reasignaciones: [],
    }
  },

  methods: {
    obtenerReasignaciones() {
      axios.get(`api/cotizacion/${this.solicitudId}/reasignaciones`)
        .then(response => {
          this.reasignaciones = response.data.reasignaciones;
        });
    },
  },

  mounted() {
    Bus.$on("mostrar-reasignaciones", solicitudId => {
      this.reasignaciones = [];
      this.solicitudId = solicitudId;

      this.obtenerReasignaciones();

      $('#modalReasignaciones').modal({
        backdrop: 'static',
        keyboard: false
      }).toggle();
    });
  },
}
</script>



// WEBPACK FOOTER //
// resources/vue/components/cotizacion/ModalReasignaciones.vue